import { css } from '@/styled-system/css';

export const calendarBodyStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  rowGap: 'tighter',
  borderSpacing: 0,
});

export const calendarBodyHeaderStyles = css.raw({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
});

export const calendarBodyGridStyles = css.raw({
  paddingInline: 'tightest',
  display: 'grid',
  rowGap: 'tighter',
});

export const calendarBodyGridRowStyles = css.raw({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  columnGap: 'tighter',
  rowGap: 'tighter',
  minHeight: 'action.sm',
});
